import { render, staticRenderFns } from "./PowerBIPage.vue?vue&type=template&id=1ada3ab3&scoped=true&"
import script from "./PowerBIPage.vue?vue&type=script&lang=ts&"
export * from "./PowerBIPage.vue?vue&type=script&lang=ts&"
import style0 from "./PowerBIPage.vue?vue&type=style&index=0&id=1ada3ab3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada3ab3",
  null
  
)

export default component.exports